export default __webpack_public_path__ + "static/cafe_36059-04a96a3ae24130f38e46c79bf03e3472.png";